import { useContext } from 'react';

import { WhiteboardContext } from './WhiteboardContext';

const useWhiteboardContext = () => {
  const context = useContext(WhiteboardContext);
  if (!context) {
    throw new Error('WhiteBoardContext must be a child of MainProvider');
  }
  return { ...useContext(WhiteboardContext) };
};
export default useWhiteboardContext;
